<div class="pop" [ngClass]="{'modeone': isModeOne, 'modetwo': isModeTwo}">
  <div class="content">
    <div class="top">
      <div *ngIf="product.has_image" class="img">
        <img class="ya_image" [src]="product.image_path">
      </div>

      <div *ngIf="!product.has_image" class="noimg">
        <ng-container *ngIf="!is_extra_product">
          <h2>{{product.label}}</h2>
        </ng-container>
        <ng-container *ngIf="is_extra_product">
          <h2>{{setExtraProductLabel()}}</h2>
        </ng-container>
      </div>

      <div class="content-inner" #product_content>
        <header>
          <ng-container *ngIf="!is_extra_product">
            <h2>{{product.label}}</h2>
          </ng-container>
          <ng-container *ngIf="is_extra_product">
            <h2>{{setExtraProductLabel()}}</h2>
          </ng-container>
          <div *ngIf="!is_info_type" class="price">{{product.price | price}}</div>
        </header>

        <p>{{product.details.description}}</p>

        <sot-properties [product]="product"></sot-properties>
      </div>

      <div class="scroll-bottom" *ngIf="show_product_content_bottom_scroll" inlineSVG="sot/sot-icon.svg#sot-down_arrows"
        [setSVGAttributes]="{class: 'arrows'}"></div>
    </div>
  </div>

  <footer class="buttons">
    <a class="btn" (click)="Close()" langkey="button_back"></a>
    <a *ngIf="!is_info_type" (click)="Add()" class="btn action"><span langkey="button_add"></span><!--hinzufügen-->
      <div inlineSVG="sot/sot-icons.svg#sot-basket" flex [setSVGAttributes]="{class: 'cart'}"></div>
    </a>
  </footer>
</div>